import './Profile.css'

export default function Profile() {
    return (
        <div className="profile">
            <h1>Check your profile here</h1>
        </div>
        
    )
}